exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-title[data-v-7b206a13]{font-size:24px;font-weight:700;margin:0;padding-top:16px;padding-left:32px;padding-right:32px}@media(max-width:767.98px){.dialog-title[data-v-7b206a13]{padding-left:16px;padding-right:16px}}.btn-wrap[data-v-7b206a13]{padding-left:32px;padding-right:32px;padding-bottom:32px;text-align:center}.back-button[data-v-7b206a13]{position:absolute;top:6px;left:0;z-index:40;width:40px;height:40px;padding:10px;cursor:pointer}.back-button svg[data-v-7b206a13]{display:block;width:16px;height:16px}", ""]);

// exports
